if (!customElements.get('subscription-widget')) {
  customElements.define(
    'subscription-widget',
    class SubscriptionWidget extends HTMLElement {
      constructor() {
        super();
 
        this.mainProductForm = this.closest('.product').querySelector('.product-form form[action*="/cart/add"]') || document.querySelector('.product__page form[action*="/cart/add"]') || document.querySelector('.product form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add.js"]') || document.querySelector('form[action*="/cart/add"]');
        this.currentVariant = JSON.parse(this.querySelector('#currentVariantData').textContent);
        this.sectionId = this.dataset.sectionId;
 
        this.sellingPlanFormInput;
        if (!this.mainProductForm.querySelector('input[name="selling_plan"]')) {
          this.sellingPlanFormInput = document.createElement('input');
          this.sellingPlanFormInput.setAttribute('type', 'hidden');
          this.sellingPlanFormInput.setAttribute('name', 'selling_plan');
          this.mainProductForm.appendChild(this.sellingPlanFormInput);
        } else {
          this.sellingPlanFormInput = this.mainProductForm.querySelector('input[name="selling_plan"]');
        }
        this.sellingPlanFormInput.setAttribute('value', '');
 
        // update when variant changes (works with Broadcast, Prestige, Dawn & co, Impulse)
        if (this.mainProductForm.querySelector('input[name="id"]') !== null) {
          this.mainProductForm.querySelector('input[name="id"]').addEventListener('change', (event) => {
            this.handleVariantChange(event.target.value);
          });
        } else {
          if (typeof subscribe === 'function') {
            this.variantChangeSubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              this.handleVariantChange(event.data.variant.id);
            });
          } else {
            document.addEventListener('variant:change', (event) => {
              this.handleVariantChange(event.detail.variant.id);
            });
          }
        }
      }
 
      connectedCallback() {
        // update when purchase type changes
        this.querySelectorAll('input[name="purchase_type"]').forEach((input) => {
          input.addEventListener('change', this.handleSellingPlanInput.bind(this));
        });
 
        // update when selling plan changes
        if (this.querySelector('.select__select')) {
          this.querySelector('.select__select').addEventListener('change', this.handleSellingPlanInputChange.bind(this));
        }
      }
 
      handleVariantChange(variant_id) {
        this.toggleLoadingMode();
        this.renderSubscriptionWidget(variant_id);
      }
 
      async renderSubscriptionWidget(variant_id) {
        const productUrl = this.dataset.url;
        const requestedVariantId = variant_id;
        const sectionId = this.dataset.sectionId;
        fetch(`${productUrl}?variant=${requestedVariantId}&section_id=${sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHtml = new DOMParser().parseFromString(responseText, 'text/html');
            const source = responseHtml.getElementById(`subscription-widget__${this.dataset.sectionId}`);
            const destination = this;
            if (source && destination) destination.innerHTML = source.innerHTML;
            destination.connectedCallback();
            this.currentVariant = JSON.parse(this.querySelector('#currentVariantData').textContent);
            this.toggleLoadingMode();
          })
          .catch((error) => {
            console.error("Erreur en tentant de rafraichir le widget d'abonnement:", error);
            this.toggleLoadingMode();
          });
      }
 
      handleSellingPlanInputChange(e) {
        this.updateSubscribePrices(e);
        this.handleSellingPlanInput(e);
      }
 
      updateSubscribePrices(e) {
        const priceContainer = this.querySelector('.subscription-widget__option--subscription .subscription-widget__option-price span');
        const selectedOption = e.target.options[e.target.selectedIndex];
        const adjustementType = selectedOption.dataset.ajustmentType;
        const adjustementValue = parseFloat(selectedOption.dataset.ajustmentValue);
 
        let adjustedPrice;
 
        switch (adjustementType) {
          case 'fixed_amount':
            adjustedPrice = this.currentVariant.price - adjustementValue;
            break;
          case 'percentage':
            adjustedPrice = this.currentVariant.price * (1 - adjustementValue / 100);
            break;
          case 'price':
            adjustedPrice = adjustementValue;
            break;
          default:
            adjustedPrice = this.currentVariant.price;
            break;
        }
 
        priceContainer.innerText = formatPrice(adjustedPrice);
        this.updateSubscribeSavingPercentage(adjustedPrice);
      }
 
      updateSubscribeSavingPercentage(finalPrice) {
        const savingPercentageContainers = this.querySelectorAll('.subscription-widget__dynamic-discount');
        const variantPrice = this.currentVariant.price / 100;
        var finalPrice = finalPrice / 100;
        if (!savingPercentageContainers || variantPrice === finalPrice) return;
        savingPercentageContainers.forEach((container) => {
          const saving = ((variantPrice - finalPrice) / variantPrice) * 100;
          container.innerText = Math.round(saving) + '%';
        });
      }
 
      handleSellingPlanInput(e) {
        const selectedOption = e.target.closest('.subscription-widget__option');
        if (selectedOption) {
          selectedOption.querySelector('input[name="purchase_type"]').checked = true;
          this.querySelectorAll('.subscription-widget__option').forEach((option) => option.classList.remove('subscription-widget__option--selected'));
          selectedOption.classList.add('subscription-widget__option--selected');
        }
 
        if (selectedOption.classList.contains('subscription-widget__option--subscription')) {
          this.sellingPlanFormInput.value = selectedOption.querySelector('.select__select').options[selectedOption.querySelector('.select__select').selectedIndex].dataset.value;
        } else {
          this.sellingPlanFormInput.removeAttribute('value');
        }
      }
 
      toggleLoadingMode() {
        this.classList.toggle('subscription-widget--loading');
      }
    }
  );
}